import { useEffect, useState } from 'react';
import { isEmpty } from '../utils/utils';
import { useSnackbar } from 'notistack';
import { useLazyQuery } from '@apollo/client';
import CustomError from '../components/CustomError/CustomError';
import { handleGraphQLError } from './utils';

function useNRLazyQuery({ query, options, qlObjKey, transformData, defaultValue }) {
  const [isCanceled, setIsCanceled] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [total, setTotal] = useState(0);
  const [result, setResult] = useState(null);

  const [customLoading, setCustomLoading] = useState(false);

  const [makeCall, { loading, error, response, called, startPolling, stopPolling, previousData }] = useLazyQuery(query, {
    ...options,
    notifyOnNetworkStatusChange: true,
    skip: options.skipPollAttempt && options.skipPollAttempt(),
    onCompleted: data => {
      try {
        onCompleted(data);

        if (options?.onCompleted) {
          options.onCompleted(data);
        }
      } finally {
        setCustomLoading(false);
      }
    },
    onError: error => {
      setCustomLoading(false);
      if (options?.onError) {
        options.onError(error);
      }
    }
  });

  const handleMakeCall = options => {
    setIsCanceled(false);
    setCustomLoading(true);
    if (defaultValue !== undefined) {
      setResult(defaultValue);
    }
    makeCall(options);
  };

  function onCompleted(data) {
    if (!isCanceled && data && data[qlObjKey]) {
      if (data[qlObjKey].items) {
        setResult(!!transformData ? transformData(data[qlObjKey].items) : data[qlObjKey].items);
      } else {
        setResult(!!transformData ? transformData(data[qlObjKey]) : data[qlObjKey]);
      }
      if (data[qlObjKey].total || data[qlObjKey].total === 0) {
        setTotal(data[qlObjKey].total);
      }
    }
  }

  const handleCancel = () => {
    setIsCanceled(true); // Mark request as canceled
    setCustomLoading(false);
  };

  useEffect(() => {
    handleGraphQLError({
      error,
      enqueueSnackbar,
      onFinally: () => setCustomLoading(false)
    });
  }, [error]);

  return [result, customLoading, called, handleMakeCall, total, error, startPolling, stopPolling, handleCancel, isCanceled];
}

export default useNRLazyQuery;
